import { h, render, Component, createRef } from 'preact';
import { classNames, checkRequiredInvalid } from '../utils/utils';
import TxrPurchaseAccountForm from './txr-purchase-account-form';
import { PlanService } from '../plan-service.service';
import { v4 as uuidv4 } from 'uuid';
import { appConfig } from '../app.config';
import axios from 'axios';
import TxrInput from './txr-input';
import TxrPasswordInput from './txr-password-input';
import TxrCheckbox from './txr-checkbox';

class TxrTrialWorkflow extends Component {

    accountFormRef = createRef();
    state = {
        prepurchaseId: undefined,
        accountInfo: undefined,
        refresh: {},
        isPurchased: false,
        tokenData: undefined,
        errors: {
            required: 'Required field',
            phone: 'Use a North American number in the form +1 followed by 10 digits (example: +15551234567).',
            password: 'The password requirements are not met',
            repassword: 'Password does not match',
            discount: 'Error during requesting discount',
            unknowndiscount: 'Unknown discount code',
            zip: 'US or Canadian postal code required',
            card: 'Invalid card number'
        },
        agree: {
            isChecked: false
        },
        passwordModel: {
            value: '',
            invalid: false,
            errors: {},
            change: (model) => {
                const hasError = checkRequiredInvalid(model, this.state.isSubmitted) || model.checkPassword(model, this.state.isSubmitted);
                model.invalid = hasError && this.state.isSubmitted;
                this.state.invalid = this.state.invalid || model.invalid;
                this.forceUpdate();
            },
            checkPassword: (model, isSubmitted) => {
                let password = model.value;
                model.pwdMinCharacters = password.length >= 8 && /[A-Za-z]/ig.test(password);
                model.pwdNumber = /[0-9]/ig.test(password);
                model.pwdSymbol = /[^\w\*]/.test(password);
                let hasError = isSubmitted && (!model.pwdMinCharacters || !model.pwdNumber || !model .pwdSymbol);
                model.errors['password'] = hasError;
                return hasError;
            }
        },
        rePasswordModel: {
            value: '',
            invalid: false,
            errors: {},
            change: (model) => {
                const hasError = checkRequiredInvalid(model, this.state.isSubmitted) || model.checkRePassword(model, this.state.isSubmitted);
                model.invalid = hasError && this.state.isSubmitted;
                this.state.invalid = this.state.invalid || model.invalid;
                this.forceUpdate();
            },
            checkRePassword: (model, isSubmitted) => {
                let hasError = isSubmitted && this.state.passwordModel.value !== model.value;
                model.errors['repassword'] = hasError;
                return hasError;
            }
        }
    }


    componentDidMount() {
        this.state.selectedFeatures = {};
        this.planService = new PlanService();
        window.onpopstate = (e) => {
            this.restoreState();
        }
        this.restoreState();
    }
   
    goToSmsHosting() {
        localStorage.setItem(appConfig.prepurchaseAccountInfoId, undefined);
        window.location.href=
        `${appConfig.appUrl}/app/sms-hosting?purchase=${this.state.plan}&access_token=${encodeURIComponent(this.state.tokenData.access_token)}`+
        `&refresh_token=${encodeURIComponent(this.state.tokenData.refresh_token)}&refresh_token_expires_in=${this.state.tokenData.refresh_token_expires_in}&expires_in=${this.state.tokenData.expires_in}&username=${encodeURIComponent(this.state.tokenData.username)}`;
        
        /*
       window.location.href=
        `http://localhost:3000/app/sms-hosting?purchase=${this.plan}&access_token=${encodeURIComponent(this.tokenData.access_token)}`+
        `&refresh_token=${encodeURIComponent(this.tokenData.refresh_token)}&refresh_token_expires_in=${this.tokenData.refresh_token_expires_in}&expires_in=${this.tokenData.expires_in}&username=${encodeURIComponent(this.username)}`;
        */
      
    }
    isInvalid() {
        return this.state.passwordModel.invalid ||
        this.state.rePasswordModel.invalid ||
        !this.state.agree.isChecked;
    }

    scrollTop() {
        window.scroll({
            top: 0, 
            left: 0, 
            behavior: 'smooth'
        });
    }

    restoreState = () => {
        const index = window.location.href.indexOf('?');
        this.url = window.location.href.substring(0, index);
        var hashes = window.location.href.slice(index + 1).split('&');

        for (var i = 0; i < hashes.length; i++) {
            let hash = hashes[i].split('=');
            if (hash[0] === 'prepurchaseId') {
                this.state.prepurchaseId = hash[1];
            }
        }

        if(!this.state.prepurchaseId) {
            this.state.prepurchaseId = localStorage.getItem(appConfig.prepurchaseIdKey); 
            const params = { prepurchaseId: this.state.prepurchaseId };
            this.saveHistoryState(params);
        }

        if(!this.state.prepurchaseId) {
            this.state.prepurchaseId = uuidv4();
            localStorage.setItem(appConfig.prepurchaseIdKey, this.state.prepurchaseId);
            const params = { prepurchaseId: this.state.prepurchaseId };
            this.saveHistoryState(params);
        } else {
           try {
                const accountInfoStr = localStorage.getItem(appConfig.prepurchaseAccountInfoId); //, JSON.stringify(data));
                if(accountInfoStr) {
                    this.state.accountInfo = JSON.parse(accountInfoStr);
                     this.state.step1filled = this.state.refresh.accountFormRefresh(this.state.accountInfo);
                } 
            } catch {    
                this.state.step = 0;
            }
        }
        this.forceUpdate();
    }

    saveAccountInfo = (accountInfo) => {
        this.state.accountInfo = accountInfo;
        this.setState({ accountInfo: accountInfo });
        const params = { prepurchaseId: this.state.prepurchaseId };
        this.saveHistoryState(params);
    }
    saveHistoryState(params) {
        const queryString = Object.keys(params).map(function (k) {
            return encodeURIComponent(k) + '=' + encodeURIComponent(params[k])
        }).join('&');
        window.history.pushState(null, null, `${this.url}?${queryString}`);
    }
    checkAgree() {
        this.forceUpdate();
    }

    toggleHippa(value) {
        this.setState({isHippa: value});
        const params = { plan: this.state.plan, step: 1, prepurchaseId: this.state.prepurchaseId, isHippa: value };
        this.saveHistoryState(params);
    }
     purchase() {
        this.state.isSubmitted = true;
        this.setState({ isSubmitted: true });
        this.accountFormRef.current.setState({ isSubmitted: true });
        this.accountFormRef.current.validate(true);
        this.state.invalid = this.accountFormRef.current.isInvalid();
        this.state.passwordModel.change(this.state.passwordModel);
        this.state.rePasswordModel.change(this.state.rePasswordModel);
        if(this.isInvalid()) {
            return;
        }
        this.accountFormRef.current.isInvalidAsync()
        .then((invalid) => {
            if(invalid) {
                return;
            }
            this.purchaseImpl();
        });
     }
    purchaseImpl() {
        this.state.isSubmitted = true;
        this.setState({ isSubmitted: true });
        this.accountFormRef.current.continue();
        
        this.state.invalid = this.accountFormRef.current.isInvalid();
        this.state.passwordModel.change(this.state.passwordModel);
        this.state.rePasswordModel.change(this.state.rePasswordModel);
        if(this.isInvalid() || this.accountFormRef.current.isInvalid()) {
            return;
        }
         this.state.refresh.submitEvent();
        this.saveAccountInfo(this.accountFormRef.current.createData());

        grecaptcha.execute('6LfIJ-oUAAAAAEMV2HwqxT3fKvO1RxVa47bHXG3f', {action: 'purchase'}).then((token) => {

            dataLayer.push({ ecommerce: null });
            var partnerStackPartnerKey = null;
            try {
                growsumo.data.name = localRefs.txrForm.companyModel.value;
                growsumo.data.email = localRefs.txrForm.emailModel.value;
                partnerStackPartnerKey = growsumo.data.partner_key;
            } catch (e) {
                // Errors here should not interrupt purchase process
                partnerStackPartnerKey = null;
            }

            const data =
            {
                prepurchaseId: this.state.prepurchaseId, 
                firstName: this.state.accountInfo.firstName,
                lastName: this.state.accountInfo.lastName,
                company: this.state.accountInfo.company,
                phone: this.state.accountInfo.phone,
                email: this.state.accountInfo.email,
                website: this.state.accountInfo.webSiteUrl,
                password: this.state.passwordModel.value,
                recaptchaToken: token,
                partnerStackPartnerKey: partnerStackPartnerKey
            };
           
            this.setState({ isLoading: true });
            const url = appConfig.url + '/webservices/account/purchase/free-trial';
            const options = {
                method: 'POST',
                headers: { 'content-type': 'application/json; charset=utf-8' },
                data: JSON.stringify(data),
                url,
            };
            axios(options)
            .then((res) => {
                const response = res.data;
                this.setState({ isLoading: false });
                window.dataLayer = window.dataLayer || [];
                const ecommerceData = {
                            'transactionId': 0,                
                            'transactionAffiliation': 'website',
                            'transactionTotal': response.planPurchasePrice,              
                            'transactionProducts': [{                            
                                'name': response.planName,     
                                'sku': response.planId,
                                'price': response.planPurchasePrice,
                                'category': 'plan',
                                'quantity': 1
                            }]
                        };
                       
        
                const purchaseEventData = {
                    'event': 'free_trial_event', 
                    'event_category': 'ecommerce', 
                    'purchase_plan_type': response.planName, 
                    'total_purchase': response.planPurchasePrice,
                    'purchased_features': [], 
                    'transactionId': ecommerceData.transactionId,
                    'transactionAffiliation': ecommerceData.transactionAffiliation,
                    'transactionTotal': ecommerceData.transactionTotal,
                    'transactionProducts': ecommerceData.transactionProducts
                };
                 gtag('event', 'free_trial', purchaseEventData);
                this.state.tokenData = {
                    access_token: response.access_token,
                    refresh_token: response.refresh_token,
                    refresh_token_expires_in: response.refresh_token_expires_in,
                    expires_in: response.expires_in,
                    username: this.state.accountInfo.email
                };
                
                try {

                    window.lintrk('track', { conversion_id: 0 });
                } catch(e) {
                    console.error(e);
                }
                this.goToSmsHosting();
            })
            .catch((e) => {
                this.setState({ isLoading: false });
                let purchaseErrorTitle = null;
                let purchaseErrorMessage = null;
                if(e.response && e.response.status=== 400 && e.response.data) {
                    purchaseErrorTitle = 'Operation Failed';
                    purchaseErrorMessage = e.response && e.response.data ? e.response.data.errorMessage: 'Generic Error';
                }
                if(!purchaseErrorMessage ) {
                    purchaseErrorTitle = 'Operation Failed';
                    purchaseErrorMessage = 'Generic Error';
                }
                this.setState({ purchaseErrorTitle: purchaseErrorTitle, purchaseErrorMessage: purchaseErrorMessage });
            });
        });
    }
    onSubmit = e => {
        return false;
      }
    render() {
        return (
            <div class="txr-trial-workflow">
            {
               !this.state.isPurchased && 
                <div class="txr-purchase-workflow-process">
                    <div class="purchase-content">
                        <div class={classNames({ 'purchase-content__item': true })}>
                            <h2 class="purchase-content__item-title">Add account information</h2>
                            <TxrPurchaseAccountForm ref={this.accountFormRef} trial="true" prepurchaseId={this.state.prepurchaseId} plan={this.state.plan} refresh={this.state.refresh}></TxrPurchaseAccountForm>
                        </div>
                        <div class={classNames({ 'purchase-content__item': true })}>
                            <h2 class="purchase-content__item-title">Create your password</h2>
                            <form onsubmit={this.onSubmit} class="purchase__form">
                                <div class="form__item password">
                                    <TxrPasswordInput model={this.state.passwordModel} label="Password" errors={this.state.errors}></TxrPasswordInput>
                                </div>
                                <div class="form__item">
                                    <TxrInput model={this.state.rePasswordModel} label="Re-enter password" errors={this.state.errors} type={'password'}></TxrInput>
                                </div>
                                <div class="form__item checkbox txr-mt20">
                                    <div class="checkbox-item">
                                    <TxrCheckbox item={this.state.agree} select={() => this.checkAgree()}></TxrCheckbox>I agree to the&nbsp;<a target="_blank" href="/terms-of-service" class="txr-text__link">terms and conditions</a>
                                    </div>
                                    { this.state.isSubmitted && !this.state.agree.isChecked && 
                                    <div class="txr-input__errors">
                                        You must agree to the terms and conditions.
                                    </div>
                                    }
                                 </div>
                                <div class="purchase-form__button txr-mt20">
                                    <button class="txr-button txr-primary-button" disabled={this.isInvalid() && this.state.isSubmitted} type="button" onClick={() => this.purchase()}>
                                        <span class="txr-button__content">LET’S GO!
                                            {!this.state.isLoading && <i class="txr-button__angle-icon fal fa-angle-right"></i>}
                                            {this.state.isLoading && <i class="txr-button__spin-icon fas fa-circle-notch fa-spin"></i>}
                                        </span>
                                    </button>
                                </div>                                 
                            </form>
                            
                        </div>                        
                    </div>
                    {
                        !!this.state.purchaseErrorMessage &&
                            <div class="purchase-trial__error">
                                <div class="form-error__title">{ this.state.purchaseErrorTitle }</div>
                                <div class="form-error__text">{ this.state.purchaseErrorMessage }</div>
                            </div>
                    } 
                </div>
                
            }
            </div>
        )
    }
}
export default TxrTrialWorkflow;